import { Dictionary } from "./__generated__/dictionary";
import i18next, { fallbackLng } from "./i18n.config";
import { BCP47LangCode } from "./i18n.types";

export async function getTranslation(options?: GetTranslationOptions) {
  const namespace = "dictionary";
  const lang = options?.lang;

  if (lang && i18next.resolvedLanguage !== lang) {
    await i18next.changeLanguage(lang);
  }

  if (!i18next.hasLoadedNamespace(namespace)) {
    await i18next.loadNamespaces(namespace);
  }

  const langToUse = lang ?? i18next.resolvedLanguage ?? fallbackLng;

  const t = i18next.getFixedT(langToUse, namespace, options?.keyPrefix);

  return {
    i18n: i18next,
    t: (key: keyof Dictionary, values?: Record<string, string | number>) =>
      t(key, values as Record<string, unknown> | undefined),
  };
}

type GetTranslationOptions = {
  keyPrefix?: string;
  lang?: BCP47LangCode;
};
